<div class="root-sm">
  <p class="title-sm">Your Previous Month at EasyEquities</p>
</div>
